import { Enumeration } from '../types';

export class AssetClassEnum extends Enumeration {
  id: number;
  name: string;
  displayName: string;

  constructor(id: number, name: string, displayName: string) {
    super(id, name, displayName);
    this.id = id;
    this.name = name;
    this.displayName = displayName;
  }

  private static _items: AssetClassEnum[] = [];

  static loadFromApi(data: { id: number; assetClass: string }[]) {
    AssetClassEnum._items = data.map((d) => new AssetClassEnum(d.id, AssetClassEnum.cleanDisplayName(d.assetClass), d.assetClass));
  }

  static getById(id: number | null | undefined): AssetClassEnum | undefined {
    return AssetClassEnum._items.find((t) => t.id === id);
  }

  static getByName(name: string): AssetClassEnum | undefined {
    return AssetClassEnum._items.find((t) => t.name.toLowerCase() === name.toLowerCase());
  }

  static getAll(): AssetClassEnum[] {
    return [...AssetClassEnum._items];
  }

  // Duplicate display names was breaking input fields
  static getAllUnique(): AssetClassEnum[] {
    return this.getAll().filter((value: AssetClassEnum, index: number, array: AssetClassEnum[]) =>
      index === array.findIndex((otherValue: AssetClassEnum) => otherValue.displayName === value.displayName)
    );
  }

  private static cleanDisplayName(input: string): string {
    return input.replace(/[^a-zA-Z0-9]/g, '');
  }
}
